const calculateDate = (initialDate: Date, countDays: number): Date => {
  const result = initialDate;
  result.setHours(0);
  result.setMinutes(0);
  var pastDate = result.getDate() + countDays;

  result.setDate(pastDate);
  return result;
};

const getDateFormatted = (date: Date): string => {
  const day = date.getDate();
  const month = date.getMonth() + 1; //January is 0!

  const yyyy = date.getFullYear();
  const dd = day < 10 ? "0" + day : day;
  const mm = month < 10 ? "0" + month : month;
  return dd + "/" + mm + "/" + yyyy;
};

function isValidDate(d: unknown): boolean {
  return d instanceof Date && !isNaN(d.getTime());
}

const getDay = (): number => {
  return new Date().getDay() - 1;
};
const getDaysOfThisMonth = (): number => {
  return new Date().getDate() - 1;
};

const getDaysOfLastMonth = (): number => {
  const today = new Date();
  today.setMonth(today.getMonth() - 1);
  return getDay() + today.getDate() - 1;
};

const minDate = (dates: Date[]): Date => {
  return new Date(Math.min.apply(null, dates.map(Number)));
};

const getLastDayOfThisMonth = (date: Date): Date => {
  //const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDay;
};

export {
  calculateDate,
  getDateFormatted,
  isValidDate,
  getDay,
  getDaysOfThisMonth,
  getDaysOfLastMonth,
  minDate,
  getLastDayOfThisMonth,
};
